import { Card, Descriptions, Image, Space, Tag, Typography } from "antd";
import { revisarFocoClinico } from "../../../../../Utils/focoClinico";

const { Text } = Typography;

function mapTherapies(ids, therapyCats) {
  const map = new Map((therapyCats || []).map((t) => [String(t._id), t]));
  return (ids || [])
    .map((id) => map.get(String(id)) || { _id: id, title: String(id) })
    .filter(Boolean);
}

export function StepReview({ summary, therapyCats, bannerFileList }) {
  const therapies = mapTherapies(summary?.therapyIds, therapyCats);

  // Es la última pantalla antes de guardar: si una etiqueta no la gobierna
  // nadie, aquí es donde tiene que verse.
  const foco = revisarFocoClinico(summary?.clinicalFocus, therapyCats);
  const huerfanas = new Set(foco.huerfanas);

  const bannerUrl =
    bannerFileList?.[0]?.thumbUrl || bannerFileList?.[0]?.url || null;

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={12}>
      <Card>
        <Descriptions column={1} size="small">
          <Descriptions.Item label="Título">
            {summary?.title || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="URL Hubs">
            <Text>{summary?.hubsUrl || "—"}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Dificultad">
            {summary?.difficulty || "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Premium">
            {summary?.premium ? "Sí" : "No"}
          </Descriptions.Item>

          <Descriptions.Item label="Activa">
            {summary?.active ? "Sí" : "No"}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Banner">
        {bannerUrl ? (
          <Image
            src={bannerUrl}
            alt="Banner"
            style={{ maxWidth: 360, borderRadius: 8 }}
          />
        ) : (
          "— Sin banner —"
        )}
      </Card>

      <Card title="Terapias">
        <Space wrap>
          {therapies.length
            ? therapies.map((t) => <Tag key={String(t._id)}>{t.title}</Tag>)
            : "—"}
        </Space>
      </Card>

      <Card title="Foco clínico">
        <Space wrap>
          {foco.valores.length
            ? foco.valores.map((etiqueta) => (
                <Tag
                  key={etiqueta}
                  color={huerfanas.has(etiqueta) ? "orange" : undefined}
                >
                  {etiqueta}
                </Tag>
              ))
            : "—"}
        </Space>
        {foco.huerfanas.length ? (
          <div style={{ marginTop: 8 }}>
            <Text type="warning">
              En naranja, lo que no pertenece a ninguna categoría. Se guarda,
              pero no agrupa ni filtra.
            </Text>
          </div>
        ) : null}
      </Card>

      <Card title="Descripción clínica">
        {/* pre-wrap: que la revisión enseñe los párrafos tal y como se van a guardar. */}
        <Text style={{ whiteSpace: "pre-wrap" }}>
          {summary?.clinicalDescription || "—"}
        </Text>
      </Card>
    </Space>
  );
}
